"use client";

import { CreationFlowContainer } from "./creation-flow-container";
import type { ListingData } from "@/types/listing";
import type { TUser } from "@/types/User";

interface CreationModalProps {
  open: boolean;
  onOpenChangeAction: (open: boolean) => void;
  initialScrollPosition?: number;
  user: TUser;
  /** Draft resume (all three travel together — see global-creation-modal). */
  initialData?: ListingData;
  initialStep?: number;
  draftId?: string;
}

export function CreationModal({
  open,
  onOpenChangeAction,
  initialScrollPosition = 0,
  user,
  initialData,
  initialStep,
  draftId,
}: CreationModalProps) {
  return (
    <CreationFlowContainer
      open={open}
      onOpenChangeAction={onOpenChangeAction}
      user={user}
      initialScrollPosition={initialScrollPosition}
      initialData={initialData}
      initialStep={initialStep}
      draftId={draftId}
    />
  );
}
